import isString from 'lodash/isString';

export default function stringToBoolean(string) {
  if (!isString(string)) {
    return string === true;
  }

  switch (string.toLowerCase()) {
    case 'true':
    case 'yes':
    case '1':
      return true;
    case 'false':
    case 'no':
    case '0':
    case null:
      return false;
    default:
      return Boolean(string);
  }
}
